var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('stock-detail',{ref:"stockDetail",attrs:{"detailType":"futureDetail","tableData":_vm.tableData,"baseInfo":_vm.baseInfo},on:{"tabChange":_vm.onTabChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }